import ApiService from './api.service';
import type { ListRecordsResponse, SingleRecordResponse } from './pipelineNode.service';
import type { AnalysisDimensionFilter } from '../utils/filterComparators';

export type { ListRecordsResponse };

export interface ContextItem {
  id: string;
  name: string;
  description?: string;
  dimension_filters: AnalysisDimensionFilter[];
  created_at?: string;
  updated_at?: string;
}

export class ContextService {
  async find(options?: {
    page?: number;
    pageSize?: number;
    filters?: Record<string, any>;
  }): Promise<ListRecordsResponse<ContextItem>> {
    const {
      page = 1,
      pageSize = 50,
      filters = {},
    } = options || {};

    const queryParams: Record<string, any> = {
      page,
      limit: pageSize,
      ...filters,
    };

    const result = await ApiService.getInstance().request(
      'GET',
      '/contextitems',
      queryParams
    ) as ListRecordsResponse<ContextItem>;

    return result;
  }

  async findById(id: string): Promise<ContextItem> {
    const result = await ApiService.getInstance().request(
      'GET',
      `/contextitems/${id}`
    ) as SingleRecordResponse<ContextItem>;
    return result.record;
  }

  async save(contextItem: Partial<ContextItem>): Promise<ContextItem> {
    const result = await ApiService.getInstance().request(
      'PATCH',
      `/contextitems/${contextItem.id}`,
      contextItem
    ) as SingleRecordResponse<ContextItem>;
    return result.record;
  }

  async create(contextItem: Partial<ContextItem>): Promise<ContextItem> {
    const result = await ApiService.getInstance().request(
      'POST',
      '/contextitems',
      contextItem
    ) as SingleRecordResponse<ContextItem>;
    return result.record;
  }

  async delete(id: string): Promise<void> {
    await ApiService.getInstance().request(
      'DELETE',
      `/contextitems/${id}`
    );
  }
}

export const contextService = new ContextService();
